import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Flex from 'components/Flex'
import { RadioContext } from 'components/Radio/RadioGroup'
import { colors } from 'theme/default'

export const RadioContainer = styled(Flex).attrs(() => ({
  flexDirection: 'row',
  alignItems: 'center'
}))`
  ${props => !props.disabled ? 'cursor: pointer;' : ''}
`

const HiddenInput = styled.input.attrs(() => ({
  type: 'radio'
}))`
  opacity: 0;
  position: absolute;
  pointer-events: none;
  display: none;
`

const DotContainer = styled(Flex).attrs(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0
}))`
  border-radius: 100%;
  height: ${props => props.size === 'small' ? '18px' : '24px'};
  width: ${props => props.size === 'small' ? '18px' : '24px'};
  background-color: transparent;
  border-width: 2px;
  border-style: solid;
  border-color: ${props => props.theme.buttonColor};
  border-radius: 15px;
  ${props => props.disabled ? 'opacity: 0.5;' : ''}
`
DotContainer.defaultProps = {
  theme: {
    buttonColor: colors.brandPrimary
  }
}

const Dot = styled.div`
  height: 0;
  width: 0;
  border-width: ${props => props.size === 'small' ? '4px' : '6px'};
  border-style: solid;
  border-color: inherit;
  border-radius: 100%;
  transform: scale(${props => props.checked ? '1' : '0'});
  transition: transform 0.2s ease-in-out;
`
Dot.defaultProps = {
  theme: {
    buttonColor: colors.brandPrimary
  }
}

export const DotComponent = ({ checked, disabled, size, className }) => (
  <DotContainer checked={checked} disabled={disabled} size={size} className={className}>
    <Dot checked={checked} disabled={disabled} size={size} />
  </DotContainer>
)
DotComponent.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.string
}

class Radio extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string, // injected from RadioContext
    Container: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    value: PropTypes.string.isRequired,
    selected: PropTypes.string,
    onRadioChange: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    size: PropTypes.string,
    children: PropTypes.oneOfType([ PropTypes.func, PropTypes.element, PropTypes.string ])
  }

  static defaultProps = {
    Container: RadioContainer,
    disabled: false,
    onClick: () => {},
    children: () => null
  }

  onClick = (e) => {
    const { onRadioChange, value, disabled, onClick } = this.props
    !disabled && onRadioChange(value)
    onClick({ disabled, value })
  }

  render () {
    const { Container, className, disabled, value, name, selected, children, onClick, size, ...props } = this.props
    const checked = selected === value

    return (
      <Container className={className} onClick={this.onClick} checked={checked} disabled={disabled} {...props}>
        <HiddenInput value={value} name={name} checked={checked} disabled={disabled} />
        {typeof children === 'function' ? children({ checked, disabled }) : (
          <React.Fragment>
            <DotComponent checked={checked} disabled={disabled} size={size} />
            {children}
          </React.Fragment>
        )}
      </Container>
    )
  }
}

const RadioWrapper = (props) => (
  <RadioContext.Consumer>
    {({ name, selected, onRadioChange }) => (<Radio {...props} name={name} selected={selected} onRadioChange={onRadioChange} />)}
  </RadioContext.Consumer>
)

export default RadioWrapper
